// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dbCk7","support":"styles_support__26jZ9"};